module.exports = __webpack_public_path__ + "static/media/Obsession.6ae8553c.jpeg";